<meta
  name="viewport"
  content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
/>
<div class="wrapper" [ngClass]="{ fullscreen: isFullScreenComputed() }">
  @if (headerDisplayed()) {
    <div class="header">
      <infl-drawing-header
        [enableHistory]="enableHistory()"
        [enableBackground]="enableBackground()"
        [enableMove]="enableMove()"
        [enableZoom]="enableZoom()"
        [textCancel]="textCancel()"
        [textSave]="textSave()"
        [drawThickness]="drawThickness()"
        [highlightThickness]="highlightThickness()"
        [eraserThickness]="eraserThickness()"
        (actionClick)="onActionClickHeader($event)"
      />
    </div>
  }
  <div class="canvas">
    <infl-drawing-canvas
      [height]="height()"
      [color]="currentColor()"
      [thickness]="computedThickness()"
      [opacity]="opacity()"
      [mode]="mode()"
      [history]="history()"
      (drawingChange)="onDrawingChange($event)"
      (historyChange)="onHistoryChange($event)"
    />
  </div>
</div>

<inf-dialog
  [type]="DialogType.confirm"
  [title]="'Quittez'"
  [confirmText]="{ yes: 'Quitter', no: 'Annuler' }"
  (action)="onActionDialog($event)"
>
  En confirmant, vos modifications ne seront pas enregistrées. Voulez-vous
  continuer ?
</inf-dialog>
